import React from 'react';
import { Box } from '@availity/element';
import HeroSection from './HeroSection';
import LogoGrid from './LogoGrid';
import DirectToPayerSection from './DirectToPayerSection';
import MCPSection from './MCPSection';
import ApiGatewaySection from './ApiGatewaySection';
import SecuritySection from './SecuritySection';
import ScalableSection from './ScalableSection';
import APICatalogSection from './APICatalogSection';
import CustomerFocusSection from './CustomerFocusSection';
import EndCapSection from './EndCapSection';

const HomePage: React.FC = () => (
  <Box sx={{ overflowX: { xs: 'hidden', md: 'visible' } }}>
    <HeroSection />
    <LogoGrid />
    <DirectToPayerSection />
    <MCPSection />
    <ApiGatewaySection />
    <SecuritySection />
    <ScalableSection />
    <APICatalogSection />
    <CustomerFocusSection />
    <EndCapSection />
  </Box>
);

export default HomePage;